// <auto-generated />
// ATENCAO: Arquivo auto-gerado pelo SetupController. Nao altere manualmente.

export const PED_VEN_MODO_PRECIFIC = {
  PrecificacaoPorTabela: 'PED_VEN_MODO_PRECIFIC1',
  PrecificacaoDeProjeto: 'PED_VEN_MODO_PRECIFIC2',
  // Mapa de sequencia (SequenciaLista) para lookup por codigo
  sequencia: {
    PED_VEN_MODO_PRECIFIC1: 1,
    PED_VEN_MODO_PRECIFIC2: 2
  }
}
